import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Paper, Box, Typography} from '@material-ui/core';
import PropTypes from 'prop-types';
import {Redirect, withRouter} from 'react-router-dom';
import {User} from '../../services';
import {SpinnerHexagone} from '../../components';
import {setUser} from '../../store/auth/actions';
import TextField from "@material-ui/core/TextField";
import Button from '@material-ui/core/Button';
import Error from '@material-ui/icons/Error';
import Warning from '@material-ui/icons/Warning';
import HighlightOff from '@material-ui/icons/HighlightOff';
import {RadioGroup} from "@material-ui/core";
import Container from '@material-ui/core/Container'
import {postLogin} from "../../resources/services/home";

class Login extends Component {

    constructor(props) {
        super(props);
        this.state = {
            connectionEffectuee: false,
            unauthorized: false,
            login: '',
            pwd: '',
            error: '',
        };
    }

    // async componentDidMount() {
    //     const {setStoreUser} = this.props;
    //     User.logUserSSO().then(async (response) => {
    //
    //     }).catch(() => this.setState({unauthorized: true}));
    // }
    //
    //
    // generateRender() {
    //     const {currentUser} = this.props;
    //     return (
    //         currentUser.token ? (
    //             <Redirect to="/admin"/>
    //         ) : (
    //             <Box width="100%" height="100%" className="loginPanel">
    //
    //                 <div>
    //                     <Paper className="paperLoginEchec">
    //                         <Typography className="typoLoginEchec">
    //                             Vous n&apos;êtes pas autorisé à acceder à l'administration de la satisfaction client
    //                         </Typography>
    //                     </Paper>
    //                 </div>
    //             </Box>
    //         )
    //     );
    // }

    onChange(event, type) {
        let value = event.target.value;
        if (type === 'login') {
            this.setState({login: value});
        } else if (type === 'pwd') {
            this.setState({pwd: value});

        }
    }

    async connectUser() {
        if (this.state.login && this.state.pwd) {
            const {setStoreUser} = this.props;
            postLogin([this.state.login, this.state.pwd])
                .then(async (response) => {
                    const user = {
                        email: response.data.users.login + '@altitudeinfra.fr',
                        username: response.data.users.login,
                        firstName: response.data.users.prenom,
                        lastName: response.data.users.nom,
                        token: response.data.token,
                    };
                    await setStoreUser(user);
                }).catch((error) => {
                if (error.response.status === 403) {
                    this.setState({error: error.response.status});
                } else if (error.response.status === 401) {
                    this.setState({error: error.response.status});
                }
            });
        } else {
            this.setState({error: "vide"});
        }
    }

    loginError() {
        const {error} = this.state;
        if (error === 401) {
            return (<Container maxWidth="sm" style={{margin: '10% auto 0 auto'}}>
                <Typography component="div" style={{backgroundColor: '#ffb84d', height: '5%', borderRadius: '15px'}}>
                    <Warning style={{float: 'left', marginRight: '1%', margin: '1% 1% 0% 1%'}}/><p
                    style={{fontSize: '15px'}}>Vous n'avez pas l'autorisation d'accèder à l'administration</p>
                </Typography>
            </Container>)
        } else if (error === 403) {
            return (<Container maxWidth="sm" style={{margin: '10% auto 0 auto'}}>
                <Typography component="div" style={{backgroundColor: '#ff8080', height: '5%', borderRadius: '15px'}}>
                    <HighlightOff style={{float: 'left', marginRight: '1%', margin: '1% 1% 0% 1%'}}/><p
                    style={{fontSize: '15px'}}>Mot de passe ou nom d'utilisateur incorrect</p>
                </Typography>
            </Container>)
        } else if (error === "vide") {
            return (<Container maxWidth="sm" style={{margin: '10% auto 0 auto'}}>
                <Typography component="div" style={{backgroundColor: '#ff8080', height: '5%', borderRadius: '15px'}}>
                    <Error style={{float: 'left', marginRight: '1%', margin: '1% 1% 0% 1%'}}/><p
                    style={{fontSize: '15px'}}>Veuillez remplir tous les champs</p>
                </Typography>
            </Container>)
        }
    }

    render() {

        const {currentUser} = this.props;
        const {connectionEffectuee, unauthorized} = this.state;

        return (
            currentUser.token ? (
                <Redirect to="/admin"/>
            ) : (
                <div style={{margin: 'auto', width: '50%'}}>
                    <div>
                        <Box component="div" display="inline" p={1} m={1}>
                            <h1>Questionnaire Satisfaction Client</h1>
                            {this.loginError()}
                            <TextField
                                required
                                id="standard-required"
                                label="Nom utilisateur"
                                placeholder="Utilisateur"
                                fullWidth
                                style={{float: 'left'}}
                                margin="normal"
                                onChange={(e) => this.onChange(e, 'login')}
                            />
                            <TextField
                                required
                                id="standard-password-input"
                                label="Password"
                                type="password"
                                fullWidth
                                style={{float: 'left'}}
                                autoComplete="current-password"
                                margin="normal"
                                onChange={(e) => this.onChange(e, 'pwd')}
                            />
                            <Button
                                variant="contained"
                                color="primary"
                                onClick={() => {
                                    this.connectUser();
                                }}
                            >
                                Connexion
                            </Button>
                        </Box>
                    </div>
                </div>
            )
        )
    }

}

Login.propTypes = {
    setStoreUser: PropTypes.func.isRequired,
    currentUser: PropTypes.shape({
        firstName: PropTypes.string,
    }).isRequired,
};

Login.defaultProps = {};

export default connect(
    state => ({
        currentUser: state.auth,
    }),
    dispatch => ({
        setStoreUser: (user) => {
            dispatch(setUser(user));
        },
    }),
)(withRouter(Login));
